"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPhoneRegistered = isPhoneRegistered;
var _isPhoneRegistered = require("../../repositories/users/v1/is-phone-registered");
var _types = require("./types");
async function isPhoneRegistered(dependencies, parameters) {
  const {
    httpApi,
    logger
  } = dependencies;
  try {
    const isPhoneRegisteredResponse = await (0, _isPhoneRegistered.fetchIsPhoneRegistered)({
      httpApi,
      parameters
    });
    if (isPhoneRegisteredResponse.statusCode === 400) {
      return {
        status: _types.ECheckPhoneStatus.Failed,
        message: isPhoneRegisteredResponse.response.message
      };
    }
    return {
      status: _types.ECheckPhoneStatus.Succeed,
      isRegistered: !!isPhoneRegisteredResponse.response.isRegistered
    };
  } catch (ex) {
    logger.error(ex, {
      domain: 'auth-widget.api.isPhoneRegistered'
    });
    return {
      status: _types.ECheckPhoneStatus.Failed,
      message: 'Произошла непредвиденная ошибка'
    };
  }
}